var map = {
	"./italy-1.jpg": 142,
	"./italy-10.jpg": 143,
	"./italy-11.jpg": 144,
	"./italy-12.jpg": 145,
	"./italy-13.jpg": 146,
	"./italy-14.jpg": 147,
	"./italy-15.jpg": 148,
	"./italy-16.jpg": 149,
	"./italy-17.jpg": 150,
	"./italy-18.jpg": 151,
	"./italy-19.jpg": 152,
	"./italy-2.jpg": 153,
	"./italy-20.jpg": 154,
	"./italy-21.jpg": 155,
	"./italy-22.jpg": 156,
	"./italy-23.jpg": 157,
	"./italy-24.jpg": 158,
	"./italy-25.jpg": 159,
	"./italy-3.jpg": 160,
	"./italy-4.jpg": 161,
	"./italy-5.jpg": 162,
	"./italy-6.jpg": 163,
	"./italy-7.jpg": 164,
	"./italy-8.jpg": 165,
	"./italy-9.jpg": 166
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 141;